// デザインボード：画面デザイン（.pen / OpenPencil）と業務フローボード（Excalidraw）。doc/design/pm-design-board-screens.html
export default {
  "design.tab": "设计",
  "design.page.entry": "设计（白板 / .pen）",
  "design.page.title": "设计",
  "design.page.titleOf": "{name} · 设计",
  "design.page.subtitle":
    "用截图、便签和箭头梳理流程，并与 .pen 原稿一起做版本管理和评审",
  "design.page.new": "新建",
  "design.page.filteredByTask": "仅显示任务「{name}」的设计",
  "design.page.showAll": "显示全部",
  "design.empty": "还没有设计",
  "design.untitled": "未命名业务流程板",
  "design.back": "返回列表",
  "design.more": "更多",
  "design.retry": "重试",
  "design.saved": "已保存为 v{rev}",
  "design.col.title": "标题",
  "design.col.format": "类型",
  "design.col.task": "关联任务",
  "design.col.revision": "版本",
  "design.col.updated": "更新",
  "design.format.excalidraw": "业务流程",
  "design.format.pen": "画面设计",
  "design.deleteConfirm": "确定删除「{title}」？",
  "design.deleteHint": "所有版本和评审评论将从列表中移除。",
  "design.edit.title": "编辑设计",
  "design.edit.taskHint": "留空则作为整个项目的设计。",
  "design.field.title": "标题",
  "design.field.titlePlaceholder": "留空则使用「未命名白板」或文件名",
  "design.field.task": "关联任务",
  "design.field.note": "变更说明",
  "design.create.title": "创建设计",
  "design.create.ok": "创建",
  "design.create.mode": "创建方式",
  "design.create.blank": "空白板",
  "design.create.file": "从 .excalidraw 文件导入",
  "design.file.drop": "拖放文件，或点击选择",
  "design.file.hint": ".excalidraw · 最大 {mb}MB（含图片）",
  "design.file.need": "请选择文件",
  "design.source.title": "Git 来源（可选）",
  "design.source.hint":
    "记录文件在 Git 中的位置。请勿填写凭据（含令牌的 URL）。不会自动 pull / push。",
  "design.source.repo": "仓库",
  "design.source.ref": "分支 / ref",
  "design.source.path": "仓库内路径",
  "design.source.commitSha": "提交 SHA",
  "design.upload.menu": "上传新版本",
  "design.upload.title": "上传新版本（v{rev}）",
  "design.upload.ok": "导入",
  "design.export.file": "导出文件",
  "design.export.manifest": "导出元数据（.design.json）",
  "design.status.dirty": "未保存",
  "design.status.saving": "保存中…",
  "design.status.saved": "已保存",
  "design.status.error": "保存失败",
  "design.leave.title": "有未保存的更改",
  "design.leave.content": "现在离开将丢失未保存的更改。",
  "design.leave.ok": "放弃并离开",
  "design.conflict.title": "其他人先保存了",
  "design.conflict.content":
    "你的更改仍保留在画面上。加载最新版本会丢弃你的更改。如有需要，请先另存为新设计或下载草稿。",
  "design.conflict.reload": "加载最新（放弃我的更改）",
  "design.conflict.keep": "返回编辑",
  "design.conflict.saveAsCopy": "将我的更改另存为新设计",
  "design.conflict.copyTitle": "{title}（冲突副本）",
  "design.conflict.download": "下载草稿（.excalidraw）",
  "design.history.banner": "正在查看 v{rev}（只读，最新为 v{latest}）",
  "design.history.latest": "回到最新",
  "design.history.restore": "从此版本恢复",
  "design.restore.note": "从 v{rev} 恢复",
  "design.pen.limitTitle": "暂不支持在浏览器中查看和编辑 .pen",
  "design.pen.limitBody":
    "原文件会按字节原样保存和导出。OpenPencil 原生画布的嵌入与无损回写尚未验证，因此暂不提供。请按以下步骤编辑。",
  "design.pen.file": "文件名",
  "design.pen.size": "大小",
  "design.pen.download": "下载 .pen",
  "design.pen.step1": "点击「下载 .pen」获取原文件",
  "design.pen.step2": "用 OpenPencil 等支持 .pen 的工具打开并编辑保存",
  "design.pen.step3":
    "通过「从文件导入新版本」上传（若他人已推进版本则会被拒绝）",
  "design.comment.title": "评审",
  "design.comment.scopeRev": "v{rev}",
  "design.comment.scopeAll": "全部版本",
  "design.comment.none": "还没有评论",
  "design.comment.loadFailed": "无法加载评论",
  "design.comment.placeholder": "评论 v{rev}",
  "design.comment.post": "发表评论",
  "design.comment.empty": "请输入评论",
  "design.comment.resolved": "已解决",
  "design.comment.resolvedBy": "{name} 已解决",
  "design.comment.deleteConfirm": "确定删除这条评论？",
  "design.task.openList": "打开设计板",
  "design.error.load": "无法加载设计",
  "design.error.notFound": "找不到设计（已删除或无权访问）",
  "design.error.parse": "无法将已保存内容读取为白板。为防止覆盖，已禁止编辑。",
  "design.error.save": "保存失败",
  "design.error.network": "无法连接服务器。你的更改仍保留在画面上。",
  "design.error.size": "数据过大（含图片最多 10MB）。请缩小图片或减少数量",
  "design.error.elements": "元素过多（最多 5000 个）",
  "design.error.embeddable": "网页嵌入元素无法保存。请删除后再保存",
  "design.error.image-missing": "图片数据缺失。请重新粘贴图片后保存",
  "design.error.image-type": "不支持该图片格式（仅 PNG / JPEG / GIF / WebP）",
  "design.error.image-size": "图片过大（每张最多 5MB）",
  "design.error.type": "请选择 .excalidraw 或 .pen 文件",
  "design.error.format": "文件类型与此设计不一致",
  "design.close": "关闭",
  "design.frame.status.draft": "草稿",
  "design.frame.status.review": "待评审",
  "design.frame.status.changes": "需修改",
  "design.frame.status.approved": "已批准",
  "design.frame.list": "画面列表",
  "design.frame.panel": "任务・评审",
  "design.frame.search": "搜索画面",
  "design.frame.collapse": "收起画面列表",
  "design.frame.expand": "展开画面列表",
  "design.frame.none": "没有画面（顶层画框）",
  "design.frame.reviewStatus": "评审状态",
  "design.frame.tasks": "关联任务",
  "design.frame.unlink": "取消关联",
  "design.frame.linkTask": "＋ 关联任务",
  "design.frame.notInLatest":
    "该画面不在最新版本中（评审状态和任务只能加在最新版本的画面上）",
  "design.frame.removed": "最新版已删除",
  "design.pen.historyBanner":
    "正在查看 v{rev}（最新为 v{latest}）。评审状态和任务为当前值",
  "design.pen.missingFonts": "部分字体无法加载，已用替代字体显示：{fonts}",
  "design.pen.viewerError": "无法显示此 .pen",
  "design.pen.loading": "正在用 OpenPencil 加载…",
  "design.pen.selectHint":
    "点击画面即可设置评审状态、任务和评论。.pen 请在 Pencil 中编辑后「上传新版本」",
  "design.pen.uploaded": "已上传 v{rev}",
  "design.board.frames": "画面 {n}",
  "design.board.filter.all": "全部",
  "design.board.newPen": "画面设计（.pen）",
  "design.board.newPenHint": "上传 .pen，用 OpenPencil 查看和评审",
  "design.board.newFlow": "业务流程板",
  "design.board.newFlowHint": "用画面、便签和箭头画业务流程（Excalidraw）",
  "design.board.empty": "还没有设计板。请从「新建」上传 .pen 或创建业务流程板",
  "design.create.penTitle": "上传画面设计（.pen）",
  "design.create.boardTitle": "创建业务流程板",
  "design.create.penHint":
    "原样保存 Pencil 制作的 .pen，并用 OpenPencil 显示（不支持在浏览器中编辑 .pen）",
  "design.file.hintPen": ".pen · 最大 {mb}MB",
  "design.flow.add": "添加画面",
  "design.flow.addTitle": "向流程板添加画面",
  "design.flow.addOk": "添加 {n} 个",
  "design.flow.pickNeed": "请选择要添加的画面",
  "design.flow.pickAll": "全选",
  "design.flow.renderFailed": "无法导出画面图片。",
  "design.flow.noPen": "本项目还没有画面设计（.pen）",
  "design.flow.renderHint":
    "图片由浏览器中的 OpenPencil 导出。评审状态和任务与画面设计共用",
  "design.flow.added": "已添加 {n} 个画面（保存后生效）",
  "design.flow.refreshed": "已更新为 v{rev} 的图片（保存后生效）",
  "design.flow.source": "来源：{design} · v{rev}",
  "design.flow.outdated": "画面设计有新版本 v{rev}",
  "design.flow.refresh": "更新为 v{rev}",
  "design.flow.frameGone": "找不到来源画面（可能已被删除）",
  "design.flow.shared": "与画面设计共用",
  "design.flow.openDesign": "在画面设计中打开",
  "design.task.empty": "没有关联到此任务的画面或流程板",
};
